// extracted by mini-css-extract-plugin
export default {"root":"ExamPDF_root__HLZAf"};